import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { resumeStudioJobs, type StudioJobModule } from "./studio-jobs";

const ALL: StudioJobModule[] = ["workflows", "email", "document"];

/**
 * Re-attach to Studio generations the server is still running for this user
 * (e.g. after a reload). Also loads the `studio` namespace the runner's toasts
 * read through i18n.t, outside React.
 */
export const useStudioJobsResume = (modules: StudioJobModule[] = ALL) => {
  useTranslation(["studio"]);
  const key = modules.join(",");
  useEffect(() => {
    void resumeStudioJobs(key.split(",") as StudioJobModule[]);
  }, [key]);
};
